module.exports = __webpack_public_path__ + "img/8b79d94.jpg";